import React from 'react';
import { Building2, Users, TrendingUp } from 'lucide-react';

export const ProvvigioniSummary = ({ provvSummary }) => (
  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4">
    <div className="bg-gradient-to-br from-amber-50 to-orange-50 border border-amber-200 rounded-xl p-4">
      <div className="flex items-center gap-2 text-amber-700 text-xs font-semibold uppercase tracking-wider">
        <Building2 size={14} /> Provvigioni Agenzia (anno)
      </div>
      <p className="text-2xl font-bold text-amber-900 mt-1">EUR {Number(provvSummary.agenzia?.totale || 0).toLocaleString('it-IT')}</p>
      <p className="text-[11px] text-amber-700/70 mt-0.5">{provvSummary.agenzia?.pratiche || 0} pratiche</p>
    </div>
    <div className="bg-gradient-to-br from-sky-50 to-blue-50 border border-sky-200 rounded-xl p-4">
      <div className="flex items-center gap-2 text-sky-700 text-xs font-semibold uppercase tracking-wider">
        <Users size={14} /> Provvigioni Collaboratori (anno)
      </div>
      <p className="text-2xl font-bold text-sky-900 mt-1">EUR {Number(provvSummary.collaboratori_totale || 0).toLocaleString('it-IT')}</p>
      <p className="text-[11px] text-sky-700/70 mt-0.5">{provvSummary.pratiche_collaboratori || 0} pratiche · {(provvSummary.collaboratori || []).length} beneficiari</p>
    </div>
    <div className="bg-gradient-to-br from-emerald-50 to-teal-50 border border-emerald-200 rounded-xl p-4">
      <div className="flex items-center gap-2 text-emerald-700 text-xs font-semibold uppercase tracking-wider">
        <TrendingUp size={14} /> Totale Anno
      </div>
      <p className="text-2xl font-bold text-emerald-900 mt-1">EUR {Number(provvSummary.totale_generale || 0).toLocaleString('it-IT')}</p>
      <p className="text-[11px] text-emerald-700/70 mt-0.5">Approvate + Erogate</p>
    </div>
  </div>
);
